import { css } from 'lit';

export default [
  css`
  :host {
    color: var(--tenable-form-error-color, #9C2121);
    font-size: var(--tenable-form-error-font-size, 100%);
  }`,
];
